module.exports = __webpack_public_path__ + "img/The I Institute-logo.7ddffd3e.png";